import view from './view.js';

export { view};



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_evaluating/evaluating_detail/index.js